var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("LfHeaderTitleComponent", {
        staticClass: "header-title",
        attrs: { title: _vm.$t("views.billing_provider_bankdrafts.title") },
      }),
      _vm.totals && _vm.totals.length
        ? _c("LfTotalsComponent", { attrs: { items: _vm.totals } })
        : _vm._e(),
      _vm.renderGrid && !_vm.showSpinnerLayer
        ? _c("GridTable", {
            ref: "grid",
            attrs: {
              itemsData: _vm.billingDataFormatted,
              gridConfiguration: _vm.gridConfiguration,
              toolbarOptions: _vm.toolbarOptionsItems,
              contextMenuItems: _vm.contextMenuItems,
              listName: _vm.listConfiguration["Alias"],
              context: _vm.context,
              archivedFilter: _vm.archivedSelectedOption,
              commandClick: _vm.onCommandClick,
              excelExportedFileName: "Pagos de proveedores",
            },
            on: {
              gridTableFilter: _vm.onGridTableFilter,
              toolbarClicked: _vm.onToolbarClicked,
              customToolbarContextMenuClick:
                _vm.onCustomToolbarContextMenuClick,
            },
          })
        : _vm._e(),
      _c("ejs-contextmenu", {
        staticClass: "context-menu-component e-contextmenu-archived",
        attrs: {
          id: _vm.idContextMenu,
          items: _vm.invoicesArchivedContextMenuItemsParsed,
          select: _vm.onInvoicesArchivedClick,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }